import * as tslib_1 from "tslib";
import { lazyInitializeNotificationDiagnostics } from 'owa-mail-notification-diagnostics';
import { lazyInitializeNotificationManager } from 'owa-notification';
import { doAuthRedirect } from 'owa-service-error';
import { getScopedPath } from 'owa-url';
import { getHostLocation } from 'owa-url/lib/hostLocation';
export default function initializeNotifications() {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var initializeNotificationDiagnostics, windowUrlPath;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, lazyInitializeNotificationDiagnostics.import()];
                case 1:
                    initializeNotificationDiagnostics = _a.sent();
                    windowUrlPath = window && window.location ? window.location.pathname : null;
                    return [4 /*yield*/, initializeNotificationDiagnostics()];
                case 2:
                    _a.sent();
                    return [4 /*yield*/, lazyInitializeNotificationManager.importAndExecute({
                            channelEndpoint: getScopedPath('/owa', windowUrlPath) + '/notificationchannel',
                            pingInterval: 300000,
                            backoffMaximum: 64000,
                            minimumReconnectInterval: 1000,
                            readyCheckTimeout: 60000,
                            handleSessionTimeout: function () {
                                doAuthRedirect(getHostLocation());
                            },
                        })];
                case 3:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    });
}
//# sourceMappingURL=initializeNotifications.js.map